import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { lighten } from '@mui/system';

const CoachCommentListTitle = styled('h4')(
  ({ theme }) => ({
    marginBottom: 6,
    fontWeight: 400,
    color: theme.isDark
      ? lighten(theme.palette.sliders.coach, 0.4)
      : theme.palette.sliders.coach,
    display: 'flex',
    alignItems: 'center',
    '.MuiSvgIcon-root': {
      marginRight: 4,
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    color: theme.palette.text.primary,
  })),
);

export default CoachCommentListTitle;
